import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

import faIR from 'antd/locale/fa_IR';
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';
import trTr from 'antd/locale/tr_TR';
import { useTranslation } from 'react-i18next';
import {  useDispatch } from 'react-redux';
import { FETCH_DRAWER_MENU } from "../redux/actions";
const UserContext = createContext();

const locales = {
  en: { locale: enUS, localeName: "EN", direction: "ltr" },
  fa: { locale: faIR, localeName: "FA", direction: "ltr" },
  ar: { locale: arEG, localeName: "AR", direction: "ltr" },
  tr: { locale: trTr, localeName: "TR", direction: "ltr" }
};

export const UserProvider = ({ children }) => {
  const { i18n } = useTranslation();

  const [userConfigs, setUserConfigs] = useState(() => {
    const savedConfig = localStorage.getItem('user_config');
    return savedConfig ? JSON.parse(savedConfig) : { locale: enUS, localeName: "EN", direction: "ltr", dark: true, collapsed: false };
  });
    const dispatch = useDispatch();

  const [collapsed, setCollapsed] = useState(userConfigs.collapsed);

  const changeLocale = useCallback((localeKey) => {
    if (!locales[localeKey]) return userConfigs;

    const newConfig = { ...userConfigs, ...locales[localeKey] };
    i18n.changeLanguage(localeKey);

    setUserConfigs(newConfig);
            dispatch({ type: FETCH_DRAWER_MENU });
    
    localStorage.setItem('user_config', JSON.stringify(newConfig));
    return newConfig;
  }, [userConfigs, i18n]);

  const userChangeConfig = (key, value) => {
    setUserConfigs((prevConfigs) => {
      const updatedConfigs = { ...prevConfigs, [key]: value };
      if (key === "locale") {
        Object.assign(updatedConfigs, changeLocale(value));
      }
      localStorage.setItem('user_config', JSON.stringify(updatedConfigs));
      setCollapsed(updatedConfigs.collapsed);
      return updatedConfigs;
    });
  };

  const handleResize = useCallback(() => {
    setCollapsed(window.innerWidth < 993);
    setUserConfigs(prevState => ({ ...prevState, collapsed: window.innerWidth < 993 }));
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
      <UserContext.Provider value={{ userConfigs, userChangeConfig, collapsed, setCollapsed }}>
        {children}
      </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
